import React, { Component } from 'react'
//route
import {Link} from "react-router-dom"
import {Navbar,Nav,NavItem} from "react-bootstrap"
import "./CustomNavbar.css"

export default class CustomNavbar extends Component {
  //every conmonents should have one render.
  //inside return create JSX code.
  render() {
    return (
        <Navbar default collapseOnSelect>
          <Navbar.Header>
              <Navbar.Brand>
                  <Link to="/">ck_jets Development</Link>
              </Navbar.Brand>
              <Navbar.Toggle/>
          </Navbar.Header>
             <Navbar.Collapse>
                 <Nav pullRight>
                 <NavItem eventKey={1} componentClass={Link} href="/" to="/">Home</NavItem>
                 <NavItem eventKey={2} componentClass={Link} href="/about" to="/about">About</NavItem>
                 <NavItem eventKey={3} componentClass={Link} href="/news" to="/news">News</NavItem>


                 </Nav>

             </Navbar.Collapse>


        </Navbar>

    )
  }
}
